// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

     
const TUIGlobalStyle = createGlobalStyle`
.tui-full-calendar-section-start-date {
  width: 276px !important !important;
}

/*! CSS Used from: https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css */
body {
  margin: 0 !important;
}
a {
  background-color: transparent !important;
}
a:active,
a:hover {
  outline: 0 !important;
}
strong {
  font-weight: 700 !important;
}
img {
  border: 0 !important;
}
button,
input,
select {
  margin: 0 !important;
  font: inherit !important;
  color: inherit !important;
}
button {
  overflow: visible !important;
}
button,
select {
  text-transform: none !important;
}
button {
  -webkit-appearance: button !important;
  cursor: pointer !important;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  padding: 0 !important;
  border: 0 !important;
}
input {
  line-height: normal !important;
}
input[type="checkbox"] {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
  padding: 0 !important;
}
table {
  border-spacing: 0 !important;
  border-collapse: collapse !important;
}
td,
th {
  padding: 0 !important;
}
@media print {
  *,
  :after,
  :before {
    color: #000 !important !important;
    text-shadow: none !important !important;
    background: 0 0 !important !important;
    -webkit-box-shadow: none !important !important;
    box-shadow: none !important !important;
  }
  a,
  a:visited {
    text-decoration: underline !important;
  }
  a[href]:after {
    content: " (" attr(href) ")" !important;
  }
  thead {
    display: table-header-group !important;
  }
  img,
  tr {
    page-break-inside: avoid !important;
  }
  img {
    max-width: 100% !important !important;
  }
  p {
    orphans: 3 !important;
    widows: 3 !important;
  }
  select {
    background: #fff !important !important;
  }
}
* {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
:after,
:before {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.42857143 !important;
  color: #333 !important;
  background-color: #fff !important;
}
button,
input,
select {
  font-family: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
}
a {
  color: #337ab7 !important;
  text-decoration: none !important;
}
a:focus,
a:hover {
  color: #23527c !important;
  text-decoration: underline !important;
}
a:focus {
  outline: thin dotted !important;
  outline: 5px auto -webkit-focus-ring-color !important;
  outline-offset: -2px !important;
}
img {
  vertical-align: middle !important;
}
p {
  margin: 0 0 10px !important;
}
ul {
  margin-top: 0 !important;
  margin-bottom: 10px !important;
}
table {
  background-color: transparent !important;
}
caption {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  color: #777 !important;
  text-align: left !important;
}
th {
  text-align: left !important;
}
label {
  display: inline-block !important;
  max-width: 100% !important;
  margin-bottom: 5px !important;
  font-weight: 700 !important;
}
input[type="checkbox"] {
  margin: 4px 0 0 !important;
  margin-top: 1px \9 !important;
  line-height: normal !important;
}
input[type="checkbox"]:focus {
  outline: thin dotted !important;
  outline: 5px auto -webkit-focus-ring-color !important;
  outline-offset: -2px !important;
}
.btn {
  display: inline-block !important;
  padding: 6px 12px !important;
  margin-bottom: 0 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.42857143 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: middle !important;
  -ms-touch-action: manipulation !important;
  touch-action: manipulation !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  background-image: none !important;
  border: 1px solid transparent !important;
  border-radius: 4px !important;
}
.btn:active:focus,
.btn:focus {
  outline: thin dotted !important;
  outline: 5px auto -webkit-focus-ring-color !important;
  outline-offset: -2px !important;
}
.btn:focus,
.btn:hover {
  color: #333 !important;
  text-decoration: none !important;
}
.btn:active {
  background-image: none !important;
  outline: 0 !important;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125) !important;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125) !important;
}
.btn-default {
  color: #333 !important;
  background-color: #fff !important;
  border-color: #ccc !important;
}
.btn-default:active,
.btn-default:focus,
.btn-default:hover {
  color: #333 !important;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}
.btn-default:active {
  background-image: none !important;
}
.btn-sm {
  padding: 5px 10px !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  border-radius: 3px !important;
}
.btn-block {
  display: block !important;
  width: 100% !important;
}
.dropdown {
  position: relative !important;
}
.dropdown-toggle:focus {
  outline: 0 !important;
}
.dropdown-toggle:after {
  content: none !important;
}
.dropdown-menu {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  z-index: 1000 !important;
  display: none !important;
  float: left !important;
  min-width: 160px !important;
  padding: 5px 0 !important;
  margin: 2px 0 0 !important;
  font-size: 14px !important;
  text-align: left !important;
  list-style: none !important;
  background-color: #fff !important;
  -webkit-background-clip: padding-box !important;
  background-clip: padding-box !important;
  border: 1px solid #ccc !important;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175) !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175) !important;
}
.dropdown-menu > li > a {
  display: block !important;
  padding: 3px 20px !important;
  clear: both !important;
  font-weight: 400 !important;
  line-height: 1.42857143 !important;
  color: #333 !important;
  white-space: nowrap !important;
}
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover {
  color: #262626 !important;
  text-decoration: none !important;
  background-color: #f5f5f5 !important;
}
/*! CSS Used from: https://uicdn.toast.com/tui.time-picker/latest/tui-time-picker.css */
.tui-timepicker * {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
.tui-timepicker select {
  font-weight: normal !important;
}
.tui-ico-colon {
  overflow: hidden !important;
  display: inline-block !important;
  width: 1px !important;
  height: 1px !important;
  line-height: 300px !important;
  background: url(data:image/png !important;base64,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)
    no-repeat !important;
}
.tui-timepicker .tui-timepicker-select {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  appearance: none !important;
  border-radius: 0 !important;
}
.tui-timepicker .tui-timepicker-select::-ms-expand {
  display: none !important;
}
.tui-timepicker {
  position: relative !important;
  top: -1px !important;
  padding: 30px 20px !important;
  font-weight: bold !important;
  border: 1px solid #aaa !important;
  background: white !important;
  text-align: center !important;
}
.tui-timepicker-row {
  width: 100% !important;
  font-size: 0 !important;
}
.tui-timepicker-column {
  display: inline-block !important;
  vertical-align: middle !important;
}
.tui-timepicker-colon {
  width: 22px !important;
}
.tui-timepicker-body .tui-timepicker-colon {
  width: 18px !important;
}
.tui-ico-colon {
  width: 2px !important;
  height: 7px !important;
  background-position: -17px -28px !important;
}
.tui-timepicker-select {
  width: 52px !important;
  height: 28px !important;
  padding: 5px 0 5px 9px !important;
  font-size: 12px !important;
  border: 1px solid #ddd !important;
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAECAYAAACHtL/sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Mzk1NDA2RTVCREIxMTFFNjhENTJFMjdDNDQ3RDJCMTEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Mzk1NDA2RTZCREIxMTFFNjhENTJFMjdDNDQ3RDJCMTEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozOTU0MDZFM0JEQjExMUU2OEQ1MkUyN0M0NDdEMkIxMSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozOTU0MDZFNEJEQjExMUU2OEQ1MkUyN0M0NDdEMkIxMSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpZ5HPgAAAAxSURBVHjaYjQ2Nv7PgBswgogzZ87gVMAEU4RLMyHABKUFyNGMbMBHJEOI1gwCAAEGAPSlBRrNcMApAAAAAElFTkSuQmCC)
    no-repeat !important;
  background-position: 100% 50% !important;
  cursor: pointer !important;
}
.tui-hidden {
  display: none !important;
}
/*! CSS Used from: https://uicdn.toast.com/tui.date-picker/latest/tui-date-picker.css */
.tui-calendar {
  position: relative !important;
  background-color: #fff !important;
  border: 1px solid #aaa !important;
  width: 274px !important;
}
.tui-calendar * {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
.tui-calendar div {
  text-align: center !important;
}
.tui-calendar caption {
  padding: 0 !important;
}
.tui-calendar caption span {
  overflow: hidden !important;
  position: absolute !important;
  clip: rect(0 0 0 0) !important;
  width: 1px !important;
  height: 1px !important;
  margin: -1px !important;
  padding: 0 !important;
}
.tui-calendar button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.tui-calendar .tui-calendar-header {
  position: relative !important;
  border-bottom: 1px solid #efefef !important;
}
.tui-calendar .tui-calendar-header-inner {
  padding: 17px 50px 15px !important;
  height: 50px !important;
}
.tui-calendar .tui-calendar-title-today {
  height: 30px !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: 34px !important;
  color: #777 !important;
  background-color: #f4f4f4 !important;
}
.tui-calendar .tui-calendar-title {
  display: inline-block !important;
  font-size: 18px !important;
  font-weight: normal !important;
  font-style: normal !important;
  line-height: 1 !important;
  color: #333 !important;
  cursor: default !important;
  vertical-align: top !important;
}
.tui-calendar-btn {
  overflow: hidden !important;
  position: absolute !important;
  top: 0 !important;
  width: 32px !important;
  height: 50px !important;
  line-height: 400px !important;
  z-index: 10 !important;
  cursor: pointer !important;
  border: none !important;
  background-color: #fff !important;
}
.tui-calendar .tui-calendar-btn-prev-month {
  left: 0 !important;
}
.tui-calendar .tui-calendar-btn-next-month {
  right: 0 !important;
}
.tui-calendar .tui-calendar-btn-prev-month:after,
.tui-calendar .tui-calendar-btn-next-month:after {
  overflow: hidden !important;
  position: absolute !important;
  top: 50% !important;
  margin-top: -5px !important;
  line-height: 400px !important;
  background: url(data:image/png !important;base64,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)
    no-repeat !important;
  content: "" !important;
}
.tui-calendar .tui-calendar-btn-prev-month:after {
  width: 6px !important;
  height: 11px !important;
  left: 50% !important;
  margin-left: -3px !important;
  background-position: 0 0 !important;
}
.tui-calendar .tui-calendar-btn-next-month:after {
  width: 6px !important;
  height: 11px !important;
  right: 50% !important;
  margin-right: -3px !important;
  background-position: -8px 0 !important;
}
.tui-calendar .tui-calendar-body-header th {
  color: #777 !important;
}
.tui-calendar .tui-calendar-body-inner {
  width: 100% !important;
  margin: 0 auto !important;
  table-layout: fixed !important;
  border-collapse: collapse !important;
  text-align: center !important;
  font-size: 12px !important;
}
.tui-calendar th {
  font-weight: normal !important;
  cursor: default !important;
}
.tui-calendar th,
.tui-calendar td {
  height: 39px !important;
  text-align: center !important;
  color: #999 !important;
}
.tui-calendar .tui-is-blocked:hover {
  cursor: default !important;
}
.tui-calendar .tui-calendar-today {
  color: #4b96e6 !important;
}
.tui-calendar .tui-calendar-prev-month,
.tui-calendar .tui-calendar-next-month {
  color: #ccc !important;
}
.tui-calendar .tui-calendar-prev-month.tui-calendar-date,
.tui-calendar .tui-calendar-next-month.tui-calendar-date {
  visibility: hidden !important;
}
.tui-datepicker {
  border: 1px solid #aaa !important;
  background-color: white !important;
  position: absolute !important;
}
.tui-datepicker * {
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
.tui-datepicker-type-date {
  width: 274px !important;
}
.tui-datepicker .tui-calendar {
  border: 0 !important;
}
.tui-datepicker .tui-calendar-title {
  cursor: pointer !important;
}
.tui-datepicker-footer .tui-timepicker {
  width: 274px !important;
  position: static !important;
  padding: 20px 46px 20px 47px !important;
  border: 0 !important;
}
.tui-datepicker-footer .tui-timepicker {
  border-top: 1px solid #eee !important;
}
.tui-datepicker .tui-is-blocked {
  cursor: default !important;
  color: #ddd !important;
}
.tui-datepicker .tui-is-selectable:hover {
  background-color: #edf4fc !important;
  cursor: pointer !important;
}
.tui-datepicker .tui-is-selectable.tui-is-selected,
.tui-datepicker.tui-rangepicker .tui-is-selectable.tui-is-selected {
  background-color: #4b96e6 !important;
  color: #fff !important;
}
.tui-datepicker.tui-rangepicker .tui-is-selected-range {
  background-color: #edf4fc !important;
}
.tui-hidden {
  display: none !important;
}
/*! CSS Used from: https://nhn.github.io/tui.calendar/latest/dist/tui-calendar.css */
.tui-full-calendar-layout {
  height: 100% !important;
  position: relative !important;
  box-sizing: border-box !important;
}
.tui-full-calendar-layout * {
  box-sizing: border-box !important;
}
.tui-full-calendar-today {
  background: rgba(218, 229, 249, 0.3) !important;
}
.tui-full-calendar-month-week-item .tui-full-calendar-weekday-grid {
  overflow-y: hidden !important;
}
.tui-full-calendar-month-week-item .tui-full-calendar-weekday-schedules {
  overflow-y: visible !important;
  height: 0 !important;
}
.tui-full-calendar-month-week-item .tui-full-calendar-today {
  background: none !important;
}
.tui-full-calendar-month-week-item
  .tui-full-calendar-today
  .tui-full-calendar-weekday-grid-date-decorator {
  display: inline-block !important;
  width: 27px !important;
  height: 27px !important;
  line-height: 27px !important;
  text-align: center !important;
  background: #135de6 !important;
  border-radius: 50% !important;
  color: #fff !important;
  font-weight: bold !important;
  margin-left: 2px !important;
}
.tui-full-calendar-weekday-grid,
.tui-full-calendar-weekday-grid-line {
  height: 100% !important;
  min-height: inherit !important;
}
.tui-full-calendar-weekday-grid {
  position: absolute !important;
  width: 100% !important;
  overflow-y: scroll !important;
}
.tui-full-calendar-weekday-border {
  border-top: 1px solid #ddd !important;
}
.tui-full-calendar-weekday-grid-line {
  position: absolute !important;
  padding: 3px !important;
}
.tui-full-calendar-weekday-grid-line .tui-full-calendar-weekday-grid-footer {
  position: absolute !important;
  bottom: 4px !important;
}
.tui-full-calendar-weekday-grid-line .tui-full-calendar-weekday-grid-date {
  display: inline-block !important;
  width: 27px !important;
  height: 27px !important;
  line-height: 27px !important;
  text-align: center !important;
}
.tui-full-calendar-weekday-schedules {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  font-size: 12px !important;
  overflow-y: scroll !important;
}
.tui-full-calendar-month {
  height: 100% !important;
  min-height: 600px !important;
}
.tui-full-calendar-month-dayname {
  width: 100% !important;
  position: absolute !important;
  font-size: 13px !important;
}
.tui-full-calendar-month-dayname-item {
  height: 100% !important;
  font-weight: bold !important;
}
.tui-full-calendar-month-week-item {
  position: relative !important;
}
.tui-full-calendar-month-week-item > div {
  height: 100% !important;
}
.tui-full-calendar-vlayout-container {
  position: relative !important;
}
.tui-full-calendar-popup {
  position: absolute !important;
  font-weight: 2.5 !important;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1) !important;
  clear: both !important;
}
.tui-full-calendar-popup-container {
  min-width: 474px !important;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1) !important;
  background-color: #fff !important;
  border: solid 1px #d5d5d5 !important;
  padding: 17px !important;
  border-radius: 2px !important;
}
.tui-full-calendar-popup-section {
  font-size: 0 !important;
  min-height: 40px !important;
}
.tui-full-calendar-section-calendar {
  width: 176px !important;
}
.tui-full-calendar-section-title {
  width: calc(100% - 36px) !important;
  padding-right: 4px !important;
}
.tui-full-calendar-section-title input {
  width: 365px !important;
}
.tui-full-calendar-button.tui-full-calendar-section-private {
  height: 32px !important;
  padding: 8px !important;
  font-size: 0 !important;
  margin-left: 4px !important;
}
.tui-full-calendar-section-private.tui-full-calendar-public
  .tui-full-calendar-ic-private {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAKdJREFUKBVjYCATMKLri46Olvn9+3fX////HUByjIyMB1hZWcuWLl36BFktikaQpl+/fl0EKhBCVgRkv2NjY9NH1syErABkE1TTdqBCWRAG8reDxKBycOUoGmHOA2pIA5kOwiA2SDVMDq4TmREaGvofhJHFcLHhfgwLC9sKNNULl0KQODCgtq1atcobxIY7lZAmkGJkNXCNIAlSwIjSCApqIgJnK0wNALoOPwSpOcq0AAAAAElFTkSuQmCC)
    no-repeat !important;
}
.tui-full-calendar-section-start-date,
.tui-full-calendar-section-end-date {
  width: 176px !important;
}
.tui-full-calendar-section-start-date input,
.tui-full-calendar-section-end-date input {
  width: 139px !important;
}
.tui-full-calendar-section-start-date:hover .tui-datepicker,
.tui-full-calendar-section-end-date:hover .tui-datepicker,
.tui-full-calendar-section-start-date:focus .tui-datepicker,
.tui-full-calendar-section-end-date:focus .tui-datepicker {
  border-color: #bbb !important;
}
.tui-full-calendar-popup-section-item:focus {
  border-color: #bbb !important;
}
.tui-full-calendar-section-date-dash {
  font-size: 12px !important;
  color: #d5d5d5 !important;
  height: 32px !important;
  padding: 0 4px !important;
  vertical-align: middle !important;
}
.tui-full-calendar-popup-section-item.tui-full-calendar-section-allday {
  border: none !important;
  padding: 0 0 0 8px !important;
  cursor: pointer !important;
}
.tui-full-calendar-popup-section-item.tui-full-calendar-section-location {
  display: block !important;
}
.tui-full-calendar-popup-section-item.tui-full-calendar-section-location input {
  width: 400px !important;
}
.tui-full-calendar-section-allday
  .tui-full-calendar-icon.tui-full-calendar-ic-checkbox {
  margin: 0 !important;
}
.tui-full-calendar-popup-section-item.tui-full-calendar-section-allday
  .tui-full-calendar-content {
  padding-left: 4px !important;
}
.tui-full-calendar-section-state {
  width: 109px !important;
}
.tui-full-calendar-section-state .tui-full-calendar-content {
  width: 58px !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}
.tui-full-calendar-popup-section-item {
  height: 32px !important;
  padding: 0 9px 0 12px !important;
  border: 1px solid #d5d5d5 !important;
  display: inline-block !important;
  font-size: 0 !important;
  border-radius: 2px !important;
}
.tui-full-calendar-popup-section-item:hover {
  border-color: #bbb !important;
}
.tui-full-calendar-popup-section-item:focus {
  border-color: #bbb !important;
}
.tui-full-calendar-popup-section-item .tui-full-calendar-icon {
  position: relative !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-title {
  top: 2px !important;
}
.tui-full-calendar-popup-section-item .tui-full-calendar-content {
  text-align: left !important;
  display: inline-block !important;
  font-size: 12px !important;
  vertical-align: middle !important;
  position: relative !important;
  padding-left: 8px !important;
}
.tui-full-calendar-section-calendar
  .tui-full-calendar-dropdown-button
  .tui-full-calendar-content {
  width: 125px !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  top: -1px !important;
}
.tui-full-calendar-popup-section-item input {
  border: none !important;
  height: 30px !important;
  outline: none !important;
  display: inline-block !important;
}
.tui-full-calendar-popup-section-item input::placeholder {
  color: #bbb !important;
  font-weight: 300 !important;
}
.tui-full-calendar-dropdown {
  position: relative !important;
}
.tui-full-calendar-dropdown:hover .tui-full-calendar-dropdown-button {
  border: 1px solid #bbb !important;
}
.tui-full-calendar-dropdown-button.tui-full-calendar-popup-section-item {
  height: 32px !important;
  font-size: 0 !important;
  top: -1px !important;
}
.tui-full-calendar-dropdown-arrow {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAHlJREFUKBVjYBgFOEOAEVkmPDxc89+/f6eAYjzI4kD2FyYmJrOVK1deh4kzwRggGiQBVJCELAZig8SQNYHEmEEEMrh69eo1HR0dfqCYJUickZGxf9WqVf3IakBsFBthklpaWmVA9mEQhrJhUoTp0NBQCRAmrHL4qgAAuu4cWZOZIGsAAAAASUVORK5CYII=)
    no-repeat !important;
}
.tui-full-calendar-dropdown-menu {
  position: absolute !important;
  top: 31px !important;
  padding: 4px 0 !important;
  background-color: #fff !important;
  border: 1px solid #d5d5d5 !important;
  border-top: none !important;
  border-radius: 0 0 2px 2px !important;
  width: 100% !important;
}
.tui-full-calendar-dropdown:hover .tui-full-calendar-dropdown-menu {
  border: 1px solid #bbb !important;
  border-top: none !important;
}
.tui-full-calendar-dropdown-menu {
  display: none !important;
}
.tui-full-calendar-dropdown-menu-item {
  height: 30px !important;
  border: none !important;
  cursor: pointer !important;
}
.tui-full-calendar-section-calendar .tui-full-calendar-dropdown-menu-item {
  width: 100% !important;
}
.tui-full-calendar-section-state .tui-full-calendar-dropdown-menu-item {
  width: 100% !important;
}
.tui-full-calendar-dropdown-menu-item:hover {
  background-color: rgba(81, 92, 230, 0.05) !important;
}
.tui-full-calendar-dropdown-menu-item .tui-full-calendar-content {
  line-height: 30px !important;
}
.tui-full-calendar-button.tui-full-calendar-popup-close {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  background-color: #fff !important;
  padding: 2px !important;
  border: none !important;
}
.tui-full-calendar-section-button-save {
  height: 36px !important;
}
.tui-full-calendar-popup-save {
  float: right !important;
}
.tui-full-calendar-popup-arrow-border,
.tui-full-calendar-popup-arrow-fill {
  position: absolute !important;
}
.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-border {
  border-top: 8px solid #d5d5d5 !important;
  border-right: 8px solid transparent !important;
  border-bottom: none !important;
  border-left: 8px solid transparent !important;
  left: calc(50% - 8px) !important;
  bottom: -7px !important;
}
.tui-full-calendar-arrow-bottom .tui-full-calendar-popup-arrow-fill {
  border-top: 7px solid #fff !important;
  border-right: 7px solid transparent !important;
  border-bottom: none !important;
  border-left: 7px solid transparent !important;
  left: -7px !important;
  bottom: 1px !important;
}
.tui-full-calendar-button {
  background: #fff !important;
  border: 1px solid #d5d5d5 !important;
  border-radius: 2px !important;
  text-align: center !important;
  outline: none !important;
  font-size: 12px !important;
  cursor: pointer !important;
  color: #333 !important;
}
.tui-full-calendar-button:hover {
  border-color: #bbb !important;
  color: #333 !important;
}
.tui-full-calendar-button:active {
  background: #f9f9f9 !important;
  color: #333 !important;
}
.tui-full-calendar-confirm {
  width: 96px !important;
  height: 36px !important;
  border-radius: 40px !important;
  background-color: #ff6618 !important;
  font-size: 12px !important;
  font-weight: bold !important;
  color: #fff !important;
  border: none !important;
}
.tui-full-calendar-confirm:hover {
  background-color: #e55b15 !important;
  color: #fff !important;
}
.tui-full-calendar-confirm:active {
  background-color: #d95614 !important;
  color: #fff !important;
}
.tui-full-calendar-icon.tui-full-calendar-calendar-dot {
  border-radius: 8px !important;
  width: 12px !important;
  height: 12px !important;
  margin: 1px !important;
}
input[type="checkbox"].tui-full-calendar-checkbox-square {
  display: none !important;
}
input[type="checkbox"].tui-full-calendar-checkbox-square + span {
  display: inline-block !important;
  cursor: pointer !important;
  line-height: 14px !important;
  margin-right: 8px !important;
  width: 14px !important;
  height: 14px !important;
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAADpJREFUKBVjPHfu3O5///65MJAAmJiY9jCcOXPmP6kApIeJBItQlI5qRAkOVM5o4KCGBwqPkcxEvhsAbzRE+Jhb9IwAAAAASUVORK5CYII=)
    no-repeat !important;
  vertical-align: middle !important;
}
input[type="checkbox"].tui-full-calendar-checkbox-square:checked + span {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMBJREFUKBWVkjEOwjAMRe2WgZW7IIHEDdhghhuwcQ42rlJugAQS54Cxa5cq1QM5TUpByZfS2j9+dlJVt/tX5ZxbS4ZU9VLkQvSHKTIGRaVJYFmKrBbTCJxE2UgCdDzMZDkHrOV6b95V0US6UmgKodujEZbJg0B0ZgEModO5lrY1TMQf1TpyJGBEjD+E2NPN7ukIUDiF/BfEXgRiGEw8NgkffYGYwCi808fpn/6OvfUfsDr/Vc1IfRf8sKnFVqeiVQfDu0tf/nWH9gAAAABJRU5ErkJggg==)
    no-repeat !important;
}
input[type="checkbox"].tui-full-calendar-checkbox-round {
  display: none !important;
}
input[type="checkbox"].tui-full-calendar-checkbox-round + span {
  display: inline-block !important;
  cursor: pointer !important;
  width: 14px !important;
  height: 14px !important;
  line-height: 14px !important;
  vertical-align: middle !important;
  margin-right: 8px !important;
  border-radius: 8px !important;
  border: solid 2px !important;
  background: transparent !important;
}
.tui-datepicker {
  left: -12px !important;
  z-index: 1 !important;
  border-color: #d5d5d5 !important;
}
.tui-full-calendar-icon {
  width: 14px !important;
  height: 14px !important;
  display: inline-block !important;
  vertical-align: middle !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-title {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAO5JREFUKBVjYCATMOLSFxkZqfHnz5+1QHktNDVbV69e7cOCJgjmQjXtB3IksMh7g8SY0CXQNTEyMlYD1fBCabhyFI3omkCq/v//PwnotC8gGq4LyIBrxKYJpBBoU15oaCgPiEbWCPYjUEIFGBBY/QS0qRWooRVIg/UBDXgMYoBtBHJSgWxsAQFWjET8BBqQBuLDNM4Can6GpAAb8ydQMADo3x0gSbDGlStX3gVqdMSjGUUTSCNKAggPD1cDOmU/EEuBJKEAQxNIHEUjSABNM1ZNIHXMIAIZXL169a2+vv5moK18QKeXAv20B1meYjYAr7xrljpOzc0AAAAASUVORK5CYII=)
    no-repeat !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-location {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAR1JREFUKBWdUTtPg1AUBiT8CydHJtv/0MTJRWAgcTK1bq0/pO3k4E4IYLo2Me46tS4wumjSpV07kAb6HXLPzaGPRZLL+c73uE/D+OdnHuaCIOhVVTUEf620pWVZ0yRJ3qW3FfR9f1zX9UgaGJumOUnT9Fn3DDzPuwPOuD9TvSzL3kizhOFJ4LnjOJc0wM0FP2Asgx0mEehHUfRHgzDzqF3GOogzbJg8V6XHFqYv4Cvqy7J8DcOwWYmw8Hwy1kHMRjcaKuEGgV82caWbZay3indagJyxcKLOlKeRdJA627YfUVaN0v6tlKbZVjCO4zW2cw91px3AxJEmOONCNoTzPP9xXZfOd6u0Bzz60RGOgmQuiuIb4S3gB0IvaoJW2QMDs1bBoH1CAQAAAABJRU5ErkJggg==)
    no-repeat !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-date {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAGpJREFUKBVjYKAGCA0N/Q/C6GZhE2cEKQoLC9v6//9/L3QN2PiMjIzbVq1a5c0EkiRWE7JasEZsJhMSI1sjC7LJq1evBvsZWQyZjRxwZNs4hDSiBA6y55EDBRsb7EdQasAmiUNsKw5x4oQBkUAeDPJ53KsAAAAASUVORK5CYII=)
    no-repeat !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-state {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAIxJREFUKBVjYCATMKLrCw8P9/z3798soLgMVO4JExNT2sqVK7cjq2VC5oDYME2MjIyNIAwUkoGKoShlQeFBOGCbVq1a1QDihoaG1gMpmO0gITAAOzUsLGzr////vWCC+GigK7YBDfUGO5VYTSADYWox/IjPNmS5UY3IoYHGBgcOKG7QxPFxt+KTJCgHAGcZJbGLRuJ2AAAAAElFTkSuQmCC)
    no-repeat !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-private {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAKpJREFUKBVjYCATMKLri46Olvn9+3fX////HUByjIyMB1hZWcuWLl36BFktikaQpl+/fl0EKhBCVgRkv2NjY9NH1syErABkE1TTdqBCWRAG8reDxKBycOUoGmHOA2pIA5kOwiA2SDVMDqYTRSNQUBIkgewkJDZYDqYR7sewsLCtQFO9YBLYaGBAbVu1apU3SA5uIyFNIMXIauAaQRKkgBGlERTURATOVpgaABRQQOK46wEAAAAAAElFTkSuQmCC)
    no-repeat !important;
}
.tui-full-calendar-icon.tui-full-calendar-ic-close {
  background: url(data:image/png !important;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAJRJREFUKBXFkNERhCAMREUbuEKohzq0Eq2DDq6Da4B60KezDORkxj+ZwchmX0IYhtdWCGFl9y5g82NtzDnPdzAaudo76ZBS+nrvPxiInMkJcs5tMcZFfqcfxdqIRiELof+BiIJPg+mExmpmvKRn3zKj7OrG9Y79szPL14A1xEP0Hgy4gBZS5R7czHj3ehSgOzkVeyfuGrBw/WLm0hsAAAAASUVORK5CYII=)
    no-repeat !important;
}
/*! CSS Used from: https://nhn.github.io/tui.calendar/latest/examples/css/default.css */
body {
  font-family: "Noto Sans", sans-serif !important;
  color: "#333" !important;
  font-size: 12px !important;
}
.btn {
  border-radius: 25px !important;
  border-color: #ddd !important;
}
.btn:hover {
  border: solid 1px #bbb !important;
  background-color: #fff !important;
}
.btn:active {
  background-color: #f9f9f9 !important;
  border: solid 1px #bbb !important;
  outline: none !important;
}
.btn:disabled {
  background-color: #f9f9f9 !important;
  border: solid 1px #ddd !important;
  color: #bbb !important;
}
.btn:focus:active,
.btn:focus,
.btn:active {
  outline: none !important;
}
.dropdown-menu {
  top: 25px !important;
  padding: 3px 0 !important;
  border-radius: 2px !important;
  border: 1px solid #bbb !important;
}
.dropdown-menu > li > a {
  padding: 9px 12px !important;
  cursor: pointer !important;
}
.dropdown-menu > li > a:hover {
  background-color: rgba(81, 92, 230, 0.05) !important;
  color: #333 !important;
}
.calendar-icon {
  width: 14px !important;
  height: 14px !important;
}
.top {
  height: 49px !important;
  border-bottom: 1px solid #bbb !important;
  padding: 16px !important;
  font-size: 10px !important;
}
.lnb {
  position: absolute !important;
  width: 200px !important;
  top: 0px !important;
  bottom: 0 !important;
  border-right: 1px solid #d5d5d5 !important;
  padding: 12px 10px !important;
  background: #fafafa !important;
}
.right {
  position: absolute !important;
  left: 200px !important;
  top: 0px !important;
  right: 0 !important;
  bottom: 0 !important;
}
.lnb label {
  margin-bottom: 0 !important;
  cursor: pointer !important;
}
.lnb-new-schedule {
  padding-bottom: 12px !important;
  border-bottom: 1px solid #e5e5e5 !important;
}
.lnb-new-schedule-btn {
  height: 100% !important;
  font-size: 14px !important;
  background-color: #ff6618 !important;
  color: #ffffff !important;
  border: 0 !important;
  border-radius: 25px !important;
  padding: 10px 20px !important;
  font-weight: bold !important;
}
.lnb-new-schedule-btn:hover {
  height: 100% !important;
  font-size: 14px !important;
  background-color: #e55b15 !important;
  color: #ffffff !important;
  border: 0 !important;
  border-radius: 25px !important;
  padding: 10px 20px !important;
  font-weight: bold !important;
}
.lnb-new-schedule-btn:active {
  height: 100% !important;
  font-size: 14px !important;
  background-color: #d95614 !important;
  color: #ffffff !important;
  border: 0 !important;
  border-radius: 25px !important;
  padding: 10px 20px !important;
  font-weight: bold !important;
}
.lnb-calendars > div {
  padding: 12px 16px !important;
  border-bottom: 1px solid #e5e5e5 !important;
  font-weight: normal !important;
}
.lnb-calendars-d1 {
  padding-left: 8px !important;
}
.lnb-calendars-d1 label {
  font-weight: normal !important;
}
.lnb-calendars-item {
  min-height: 14px !important;
  line-height: 14px !important;
  padding: 8px 0 !important;
}
.lnb-footer {
  color: #999 !important;
  font-size: 11px !important;
  position: absolute !important;
  bottom: 12px !important;
  padding-left: 16px !important;
}
.menu {
  padding: 16px !important;
}
.dropdownMenu-calendarType {
  padding: 0 8px 0 11px !important;
}
.calendarTypeName {
  min-width: 62px !important;
  display: inline-block !important;
  text-align: left !important;
  line-height: 30px !important;
}
.move-today {
  padding: 0 16px !important;
  line-height: 30px !important;
}
.move-day {
  padding: 8px !important;
  font-size: 0 !important;
}
.renderRange {
  padding-left: 12px !important;
  font-size: 19px !important;
  vertical-align: middle !important;
}
.dropdown-menu-title .calendar-icon {
  margin-right: 8px !important;
}
.calendar {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 5px !important;
  top: 64px !important;
}
/*! CSS Used from: https://nhn.github.io/tui.calendar/latest/examples/css/icons.css */
.calendar-icon {
  width: 14px !important;
  height: 14px !important;
  display: inline-block !important;
  vertical-align: middle !important;
}
.ic_view_month {
  background: url("https://nhn.github.io/tui.calendar/latest/examples/images/ic-view-month.png")
    no-repeat !important;
}
.ic_view_week {
  background: url("https://nhn.github.io/tui.calendar/latest/examples/images/ic-view-week.png")
    no-repeat !important;
}
.ic_view_day {
  background: url("https://nhn.github.io/tui.calendar/latest/examples/images/ic-view-day.png")
    no-repeat !important;
}
.ic-arrow-line-left {
  background: url("https://nhn.github.io/tui.calendar/latest/examples/images/ic-arrow-line-left.png")
    no-repeat !important;
}
.ic-arrow-line-right {
  background: url("https://nhn.github.io/tui.calendar/latest/examples/images/ic-arrow-line-right.png")
    no-repeat !important;
}
/*! CSS Used fontfaces */
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr6DRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr4TRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116 !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr5DRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr6TRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+1F00-1FFF !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr5jRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0370-03FF !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr6jRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1,
    U+01AF-01B0, U+1EA0-1EF9, U+20AB !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr6zRASf6M7VBj.woff2)
      format("woff2") !important;
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF !important;
}
@font-face {
  font-family: "Noto Sans" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  src: local("Noto Sans"), local("NotoSans"),
    url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr5TRASf6M7Q.woff2)
      format("woff2") !important;
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD !important;
}
.open > .dropdown-toggle.btn-default {
  color: #333 !important;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}
.open > .dropdown-toggle.btn-default {
  background-image: none !important;
}
.open > .dropdown-menu {
  display: block !important;
}

`;
  

export default TUIGlobalStyle;
